import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Layout, Row, Button, Spin, Modal, Select, Radio, Checkbox, Divider } from 'antd';
import './main.css';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import {
    downloadOnHireReportRequest,
    getOnHireReportSitesRequest,
} from '../../../core/order/orderActions';
import { getHireRatesRequest } from '../../../core/product/productActions';
// import { getOrderRequestCountRequest } from '../../../core/orderRequest/orderRequestActions';
import { getUserRoleAndPermissionsFromCookie } from '../../../core/utils/api';
import {
    trackOnHireReportDownload,
    trackHireRatesDownload,
    trackLogout,
} from '../../../core/utils/analytics';

const Main = (props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { initialisingDownload, onHireReportSites, isFetchingOnHireReportSites } = useSelector(state => state.order);
    // const { orderRequestCount } = useSelector(state => state.orderRequest);
    const [showMenuMobile, setShowMenuMobile] = React.useState(false);
    const [reportModalVisible, setReportModalVisible] = React.useState(false);
    const [selectedSites, setSelectedSites] = React.useState([]);
    const [reportType, setReportType] = React.useState('pdf');
    const {
        children,
        className,
        title,
        headerRightColumn,
        afterTitle,
        showMenuSidebar,
        backgroundColor,
    } = props;

    const getUserContext = getUserRoleAndPermissionsFromCookie();

    const menuItems = [
        { position: 1, label: 'Account Dashboard', link: '/account/', pattern: /^\/account\/$/ },
        { position: 2, label: 'Hire Contracts', link: '/account/hire-contracts/', pattern: /^\/account\/hire-contracts\/.*$/ },
        { position: 7, label: 'Addresses', link: '/account/addresses/', pattern: /^\/account\/addresses\/.*$/ },
        { position: 8, label: 'Contacts', link: '/account/contacts/', pattern: /^\/account\/contacts\/.*$/ },
        { position: 9, label: 'Certificates & Instructions', link: '/account/certificates-instructions/', pattern: /^\/account\/certificates-instructions\/.*$/ },
        { position: 10, label: 'Order Templates', link: '/account/saved-lists/', pattern: /^\/account\/saved-lists\/.*$/, reloadDocument: true },
        { position: 11, label: 'Notification Preferences', link: '/account/notifications/', pattern: /^\/account\/notifications\/.*$/ },
        { position: 12, label: 'Account Details', link: '/account/edit/', pattern: /^\/account\/edit\/.*$/, reloadDocument: true },
    ];

    if (getUserContext?.role.toString() === '0') {
        menuItems.push({ position: 4, label: 'Invoices', link: '/account/invoices/', pattern: /^\/account\/invoices\/.*$/ });
        menuItems.push({ position: 5, label: 'Invoice Queries', link: '/account/invoice-queries/', pattern: /^\/account\/invoice-queries\/.*$/ });
        menuItems.push({ position: 6, label: 'Payments', link: '/account/payments/', pattern: /^\/account\/payments\/.*$/ });
        // if (getUserContext?.siteUsers > 0) {
        //     menuItems.push({ position: 3, label: 'Order Requests', count: orderRequestCount, link: '/account/order-requests/', pattern: /^\/account\/order-requests\/.*$/ });
        // }
    }

    menuItems.sort((a, b) => a.position - b.position);

    const handleLogout = () => {
        trackLogout();
        document.querySelector('#logout-anchor').click(); // the logout anchor lives in the header/navbar of the site
    };

    const handleOpenReportModal = () => {
        setReportModalVisible(true);
        dispatch(getOnHireReportSitesRequest());
    };

    const handleDownloadReport = () => {
        const siteIds = selectedSites.join(',');
        trackOnHireReportDownload(reportType ? reportType.toUpperCase() : 'PDF');
        dispatch(downloadOnHireReportRequest({ type: reportType, siteIds }));
        setReportModalVisible(false);
        setSelectedSites([]);
    };

    const handleReportModalCancel = () => {
        setReportModalVisible(false);
        setSelectedSites([]);
    };

    const handleDownloadHireRates = () => {
        trackHireRatesDownload();
        dispatch(getHireRatesRequest());
    };

    // useEffect(() => {
    //     if (showMenuSidebar && getUserContext?.role.toString() === '0' && getUserContext?.siteUsers > 0) {
    //         dispatch(getOrderRequestCountRequest());
    //     }
    // }, []);

    return (
        <Spin
            spinning={initialisingDownload}>
            <Row className="container">
                <Col lg={24} xs={24}>
                    <Row justify={showMenuSidebar ? 'space-between' : 'center'}>
                        <div className="account-sidebar-menu-button" onClick={() => setShowMenuMobile(!showMenuMobile)}>
                            <Row justify="space-between" align="middle">
                                <Col>ACCOUNT</Col>
                                <Col><FontAwesomeIcon icon={faAngleDown} style={{ fontSize: '25px', color: 'white', textAlign: 'center' }} /></Col>
                            </Row>
                        </div>
                        {showMenuSidebar && (
                            <Col lg={5} xs={24}>
                                <div className="account-sidebar">
                                    <div className={`account-sidebar-menu ${showMenuMobile ? 'show-menu-mobile' : ''}`}>
                                        {menuItems.map((item) => (
                                            <Link key={item.label} to={item.link} reloadDocument={item.reloadDocument ?? false}>
                                                <div className={`${location.pathname.match(item.pattern) ? 'account-sidebar-menu-item-active' : ''} account-sidebar-menu-item`}>
                                                    {item.label}
                                                    {'count' in item && (<span style={{ backgroundColor: '#da0812', borderRadius: '50%', padding: '2px 5px', marginLeft: '28px', textAlign: 'center', color: 'white', minWidth: '20px', height: '20px', lineHeight: '14px' }}>{item.count}</span>)}
                                                </div>
                                            </Link>
                                        ))}
                                        <div onClick={handleLogout} className="account-sidebar-menu-item">
                                            <FontAwesomeIcon icon={faArrowRightFromBracket} style={{ color: '#343a40', marginRight: '10px' }} />
                                            Logout
                                        </div>
                                        <Row justify="center">
                                            <Col span={22}>
                                                <div className="account-sidebar-actions">
                                                    <Button type="primary" onClick={handleOpenReportModal}>
                                                        <Row justify="space-between" align="middle">
                                                            <Col span={21}>
                                                                ON-HIRE REPORT
                                                            </Col>
                                                            <Col span={3}>
                                                                <FontAwesomeIcon icon={faAngleDown} style={{ color: 'white', textAlign: 'center' }} />
                                                            </Col>
                                                        </Row>
                                                    </Button>
                                                    <Modal
                                                        className="on-hire-report-modal"
                                                        centered
                                                        title="Download On-Hire Report"
                                                        visible={reportModalVisible}
                                                        onCancel={handleReportModalCancel}
                                                        footer={[
                                                            <Button key="cancel" onClick={handleReportModalCancel}>Cancel</Button>,
                                                            <Button key="download" type="primary" onClick={handleDownloadReport}>Download</Button>,
                                                        ]}>
                                                        <div style={{ marginBottom: 16 }}>
                                                            <label>Select Sites</label>
                                                            <Select
                                                                className="on-hire-sites-select"
                                                                mode="multiple"
                                                                style={{ width: '100%', height: 'auto' }}
                                                                placeholder="Please select sites"
                                                                value={selectedSites}
                                                                onChange={setSelectedSites}
                                                                loading={isFetchingOnHireReportSites}
                                                                optionFilterProp="children"
                                                                maxTagCount={4}
                                                                maxTagTextLength={12}
                                                                optionLabelProp="label"
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div style={{ padding: '8px 12px' }}>
                                                                            <Checkbox
                                                                                checked={onHireReportSites?.length > 0 && selectedSites.length === onHireReportSites.length}
                                                                                indeterminate={selectedSites.length > 0 && selectedSites.length < onHireReportSites.length}
                                                                                onChange={e => {
                                                                                    if (e.target.checked) {
                                                                                        setSelectedSites(onHireReportSites?.map(s => s.SiteId));
                                                                                    } else {
                                                                                        setSelectedSites([]);
                                                                                    }
                                                                                }}>
                                                                                Select All
                                                                            </Checkbox>
                                                                        </div>
                                                                        <Divider style={{ margin: '4px 0' }} />
                                                                        {menu}
                                                                    </>
                                                                )}>
                                                                {onHireReportSites?.map(site => {
                                                                    const labelText = `${site.SiteName} ${site.ADR_ADDRESS ? `- ${site.ADR_ADDRESS}` : ''}`;
                                                                    return (
                                                                        <Select.Option key={site.SiteId} value={site.SiteId} label={labelText}>
                                                                            {labelText}
                                                                        </Select.Option>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </div>
                                                        <div>
                                                            <label style={{ display: 'block', marginBottom: 8 }}>Select Format</label>
                                                            <Radio.Group value={reportType} onChange={e => setReportType(e.target.value)}>
                                                                <Radio value="pdf">PDF</Radio>
                                                                <Radio value="excel">Excel</Radio>
                                                            </Radio.Group>
                                                        </div>
                                                    </Modal>
                                                    {getUserContext?.role.toString() === '0'
                                                        ? (
                                                            <Button
                                                                onClick={handleDownloadHireRates}
                                                                style={{ whiteSpace: 'normal', height: 'fit-content' }}>
                                                                DOWNLOAD MY HIRE RATES
                                                            </Button>
                                                        )
                                                        : null}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        )}
                        <Col lg={18} xs={24}>
                            <div className={`page-wrap ${className}`}>
                                <Layout.Content className="main-content" style={{ backgroundColor }}>
                                    <div className="header">
                                        <Row justify="space-between" align="middle">
                                            <Col span={12}>
                                                {title && <h3 style={{ display: 'inline-block' }}>{title}</h3>}
                                                {afterTitle}
                                            </Col>
                                            <Col span={12}>
                                                {headerRightColumn}
                                            </Col>
                                        </Row>
                                    </div>
                                    {children}
                                </Layout.Content>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Spin>
    );
};

Main.defaultProps = {
    children: false,
    className: '',
    // eslint-disable-next-line react/jsx-no-useless-fragment
    headerRightColumn: <></>,
    title: undefined,
    afterTitle: null,
    showMenuSidebar: true,
    backgroundColor: '#eeeef0',
};

Main.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    title: PropTypes.string,
    headerRightColumn: PropTypes.node,
    afterTitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
    showMenuSidebar: PropTypes.bool,
    backgroundColor: PropTypes.string,
};

export default Main;
